import type { SearchKey } from '@schibsted-nmp/search-frontend-clients/quest';

type AutocompleteQueryKeyVars = {
    rows: number;
    searchKey: SearchKey;
    term: string;
};

export function getAutocompleteQueryKey(vars: AutocompleteQueryKeyVars) {
    return [{ scope: 'autocomplete', ...vars }] as const;
}
